module.exports = "<p>faq-category-view works!</p>\n"